export interface CountryProps {
  name: string;
  code: string;
  dailCode: string;
}

export const countries: CountryProps[] = [
  {
    name: 'Afghanistan',
    dailCode: '+93',
    code: 'AF',
  },
  {
    name: 'Aland Islands',
    dailCode: '+358',
    code: 'AX',
  },
  {
    name: 'Albania',
    dailCode: '+355',
    code: 'AL',
  },
  {
    name: 'Algeria',
    dailCode: '+213',
    code: 'DZ',
  },
  {
    name: 'AmericanSamoa',
    dailCode: '+1684',
    code: 'AS',
  },
  {
    name: 'Andorra',
    dailCode: '+376',
    code: 'AD',
  },
  {
    name: 'Angola',
    dailCode: '+244',
    code: 'AO',
  },
  {
    name: 'Anguilla',
    dailCode: '+1264',
    code: 'AI',
  },
  {
    name: 'Antarctica',
    dailCode: '+672',
    code: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    dailCode: '+1268',
    code: 'AG',
  },
  {
    name: 'Argentina',
    dailCode: '+54',
    code: 'AR',
  },
  {
    name: 'Armenia',
    dailCode: '+374',
    code: 'AM',
  },
  {
    name: 'Aruba',
    dailCode: '+297',
    code: 'AW',
  },
  {
    name: 'Australia',
    dailCode: '+61',
    code: 'AU',
  },
  {
    name: 'Austria',
    dailCode: '+43',
    code: 'AT',
  },
  {
    name: 'Azerbaijan',
    dailCode: '+994',
    code: 'AZ',
  },
  {
    name: 'Bahamas',
    dailCode: '+1242',
    code: 'BS',
  },
  {
    name: 'Bahrain',
    dailCode: '+973',
    code: 'BH',
  },
  {
    name: 'Bangladesh',
    dailCode: '+880',
    code: 'BD',
  },
  {
    name: 'Barbados',
    dailCode: '+1246',
    code: 'BB',
  },
  {
    name: 'Belarus',
    dailCode: '+375',
    code: 'BY',
  },
  {
    name: 'Belgium',
    dailCode: '+32',
    code: 'BE',
  },
  {
    name: 'Belize',
    dailCode: '+501',
    code: 'BZ',
  },
  {
    name: 'Benin',
    dailCode: '+229',
    code: 'BJ',
  },
  {
    name: 'Bermuda',
    dailCode: '+1441',
    code: 'BM',
  },
  {
    name: 'Bhutan',
    dailCode: '+975',
    code: 'BT',
  },
  {
    name: 'Bolivia, Plurinational State of',
    dailCode: '+591',
    code: 'BO',
  },
  {
    name: 'Bosnia and Herzegovina',
    dailCode: '+387',
    code: 'BA',
  },
  {
    name: 'Botswana',
    dailCode: '+267',
    code: 'BW',
  },
  {
    name: 'Brazil',
    dailCode: '+55',
    code: 'BR',
  },
  {
    name: 'British Indian Ocean Territory',
    dailCode: '+246',
    code: 'IO',
  },
  {
    name: 'Brunei Darussalam',
    dailCode: '+673',
    code: 'BN',
  },
  {
    name: 'Bulgaria',
    dailCode: '+359',
    code: 'BG',
  },
  {
    name: 'Burkina Faso',
    dailCode: '+226',
    code: 'BF',
  },
  {
    name: 'Burundi',
    dailCode: '+257',
    code: 'BI',
  },
  {
    name: 'Cambodia',
    dailCode: '+855',
    code: 'KH',
  },
  {
    name: 'Cameroon',
    dailCode: '+237',
    code: 'CM',
  },
  {
    name: 'Canada',
    dailCode: '+1',
    code: 'CA',
  },
  {
    name: 'Cape Verde',
    dailCode: '+238',
    code: 'CV',
  },
  {
    name: 'Cayman Islands',
    dailCode: '+ 345',
    code: 'KY',
  },
  {
    name: 'Central African Republic',
    dailCode: '+236',
    code: 'CF',
  },
  {
    name: 'Chad',
    dailCode: '+235',
    code: 'TD',
  },
  {
    name: 'Chile',
    dailCode: '+56',
    code: 'CL',
  },
  {
    name: 'China',
    dailCode: '+86',
    code: 'CN',
  },
  {
    name: 'Christmas Island',
    dailCode: '+61',
    code: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands',
    dailCode: '+61',
    code: 'CC',
  },
  {
    name: 'Colombia',
    dailCode: '+57',
    code: 'CO',
  },
  {
    name: 'Comoros',
    dailCode: '+269',
    code: 'KM',
  },
  {
    name: 'Congo',
    dailCode: '+242',
    code: 'CG',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    dailCode: '+243',
    code: 'CD',
  },
  {
    name: 'Cook Islands',
    dailCode: '+682',
    code: 'CK',
  },
  {
    name: 'Costa Rica',
    dailCode: '+506',
    code: 'CR',
  },
  {
    name: "Cote d'Ivoire",
    dailCode: '+225',
    code: 'CI',
  },
  {
    name: 'Croatia',
    dailCode: '+385',
    code: 'HR',
  },
  {
    name: 'Cuba',
    dailCode: '+53',
    code: 'CU',
  },
  {
    name: 'Cyprus',
    dailCode: '+357',
    code: 'CY',
  },
  {
    name: 'Czech Republic',
    dailCode: '+420',
    code: 'CZ',
  },
  {
    name: 'Denmark',
    dailCode: '+45',
    code: 'DK',
  },
  {
    name: 'Djibouti',
    dailCode: '+253',
    code: 'DJ',
  },
  {
    name: 'Dominica',
    dailCode: '+1767',
    code: 'DM',
  },
  {
    name: 'Dominican Republic',
    dailCode: '+1849',
    code: 'DO',
  },
  {
    name: 'Ecuador',
    dailCode: '+593',
    code: 'EC',
  },
  {
    name: 'Egypt',
    dailCode: '+20',
    code: 'EG',
  },
  {
    name: 'El Salvador',
    dailCode: '+503',
    code: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    dailCode: '+240',
    code: 'GQ',
  },
  {
    name: 'Eritrea',
    dailCode: '+291',
    code: 'ER',
  },
  {
    name: 'Estonia',
    dailCode: '+372',
    code: 'EE',
  },
  {
    name: 'Ethiopia',
    dailCode: '+251',
    code: 'ET',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    dailCode: '+500',
    code: 'FK',
  },
  {
    name: 'Faroe Islands',
    dailCode: '+298',
    code: 'FO',
  },
  {
    name: 'Fiji',
    dailCode: '+679',
    code: 'FJ',
  },
  {
    name: 'Finland',
    dailCode: '+358',
    code: 'FI',
  },
  {
    name: 'France',
    dailCode: '+33',
    code: 'FR',
  },
  {
    name: 'French Guiana',
    dailCode: '+594',
    code: 'GF',
  },
  {
    name: 'French Polynesia',
    dailCode: '+689',
    code: 'PF',
  },
  {
    name: 'Gabon',
    dailCode: '+241',
    code: 'GA',
  },
  {
    name: 'Gambia',
    dailCode: '+220',
    code: 'GM',
  },
  {
    name: 'Georgia',
    dailCode: '+995',
    code: 'GE',
  },
  {
    name: 'Germany',
    dailCode: '+49',
    code: 'DE',
  },
  {
    name: 'Ghana',
    dailCode: '+233',
    code: 'GH',
  },
  {
    name: 'Gibraltar',
    dailCode: '+350',
    code: 'GI',
  },
  {
    name: 'Greece',
    dailCode: '+30',
    code: 'GR',
  },
  {
    name: 'Greenland',
    dailCode: '+299',
    code: 'GL',
  },
  {
    name: 'Grenada',
    dailCode: '+1473',
    code: 'GD',
  },
  {
    name: 'Guadeloupe',
    dailCode: '+590',
    code: 'GP',
  },
  {
    name: 'Guam',
    dailCode: '+1671',
    code: 'GU',
  },
  {
    name: 'Guatemala',
    dailCode: '+502',
    code: 'GT',
  },
  {
    name: 'Guernsey',
    dailCode: '+44',
    code: 'GG',
  },
  {
    name: 'Guinea',
    dailCode: '+224',
    code: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    dailCode: '+245',
    code: 'GW',
  },
  {
    name: 'Guyana',
    dailCode: '+595',
    code: 'GY',
  },
  {
    name: 'Haiti',
    dailCode: '+509',
    code: 'HT',
  },
  {
    name: 'Holy See (Vatican City State)',
    dailCode: '+379',
    code: 'VA',
  },
  {
    name: 'Honduras',
    dailCode: '+504',
    code: 'HN',
  },
  {
    name: 'Hong Kong',
    dailCode: '+852',
    code: 'HK',
  },
  {
    name: 'Hungary',
    dailCode: '+36',
    code: 'HU',
  },
  {
    name: 'Iceland',
    dailCode: '+354',
    code: 'IS',
  },
  {
    name: 'India',
    dailCode: '+91',
    code: 'IN',
  },
  {
    name: 'Indonesia',
    dailCode: '+62',
    code: 'ID',
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    dailCode: '+98',
    code: 'IR',
  },
  {
    name: 'Iraq',
    dailCode: '+964',
    code: 'IQ',
  },
  {
    name: 'Ireland',
    dailCode: '+353',
    code: 'IE',
  },
  {
    name: 'Isle of Man',
    dailCode: '+44',
    code: 'IM',
  },
  {
    name: 'Israel',
    dailCode: '+972',
    code: 'IL',
  },
  {
    name: 'Italy',
    dailCode: '+39',
    code: 'IT',
  },
  {
    name: 'Jamaica',
    dailCode: '+1876',
    code: 'JM',
  },
  {
    name: 'Japan',
    dailCode: '+81',
    code: 'JP',
  },
  {
    name: 'Jersey',
    dailCode: '+44',
    code: 'JE',
  },
  {
    name: 'Jordan',
    dailCode: '+962',
    code: 'JO',
  },
  {
    name: 'Kazakhstan',
    dailCode: '+77',
    code: 'KZ',
  },
  {
    name: 'Kenya',
    dailCode: '+254',
    code: 'KE',
  },
  {
    name: 'Kiribati',
    dailCode: '+686',
    code: 'KI',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dailCode: '+850',
    code: 'KP',
  },
  {
    name: 'Korea, Republic of South Korea',
    dailCode: '+82',
    code: 'KR',
  },
  {
    name: 'Kuwait',
    dailCode: '+965',
    code: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    dailCode: '+996',
    code: 'KG',
  },
  {
    name: 'Laos',
    dailCode: '+856',
    code: 'LA',
  },
  {
    name: 'Latvia',
    dailCode: '+371',
    code: 'LV',
  },
  {
    name: 'Lebanon',
    dailCode: '+961',
    code: 'LB',
  },
  {
    name: 'Lesotho',
    dailCode: '+266',
    code: 'LS',
  },
  {
    name: 'Liberia',
    dailCode: '+231',
    code: 'LR',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    dailCode: '+218',
    code: 'LY',
  },
  {
    name: 'Liechtenstein',
    dailCode: '+423',
    code: 'LI',
  },
  {
    name: 'Lithuania',
    dailCode: '+370',
    code: 'LT',
  },
  {
    name: 'Luxembourg',
    dailCode: '+352',
    code: 'LU',
  },
  {
    name: 'Macao',
    dailCode: '+853',
    code: 'MO',
  },
  {
    name: 'Macedonia',
    dailCode: '+389',
    code: 'MK',
  },
  {
    name: 'Madagascar',
    dailCode: '+261',
    code: 'MG',
  },
  {
    name: 'Malawi',
    dailCode: '+265',
    code: 'MW',
  },
  {
    name: 'Malaysia',
    dailCode: '+60',
    code: 'MY',
  },
  {
    name: 'Maldives',
    dailCode: '+960',
    code: 'MV',
  },
  {
    name: 'Mali',
    dailCode: '+223',
    code: 'ML',
  },
  {
    name: 'Malta',
    dailCode: '+356',
    code: 'MT',
  },
  {
    name: 'Marshall Islands',
    dailCode: '+692',
    code: 'MH',
  },
  {
    name: 'Martinique',
    dailCode: '+596',
    code: 'MQ',
  },
  {
    name: 'Mauritania',
    dailCode: '+222',
    code: 'MR',
  },
  {
    name: 'Mauritius',
    dailCode: '+230',
    code: 'MU',
  },
  {
    name: 'Mayotte',
    dailCode: '+262',
    code: 'YT',
  },
  {
    name: 'Mexico',
    dailCode: '+52',
    code: 'MX',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    dailCode: '+691',
    code: 'FM',
  },
  {
    name: 'Moldova',
    dailCode: '+373',
    code: 'MD',
  },
  {
    name: 'Monaco',
    dailCode: '+377',
    code: 'MC',
  },
  {
    name: 'Mongolia',
    dailCode: '+976',
    code: 'MN',
  },
  {
    name: 'Montenegro',
    dailCode: '+382',
    code: 'ME',
  },
  {
    name: 'Montserrat',
    dailCode: '+1664',
    code: 'MS',
  },
  {
    name: 'Morocco',
    dailCode: '+212',
    code: 'MA',
  },
  {
    name: 'Mozambique',
    dailCode: '+258',
    code: 'MZ',
  },
  {
    name: 'Myanmar',
    dailCode: '+95',
    code: 'MM',
  },
  {
    name: 'Namibia',
    dailCode: '+264',
    code: 'NA',
  },
  {
    name: 'Nauru',
    dailCode: '+674',
    code: 'NR',
  },
  {
    name: 'Nepal',
    dailCode: '+977',
    code: 'NP',
  },
  {
    name: 'Netherlands',
    dailCode: '+31',
    code: 'NL',
  },
  {
    name: 'Netherlands Antilles',
    dailCode: '+599',
    code: 'AN',
  },
  {
    name: 'New Caledonia',
    dailCode: '+687',
    code: 'NC',
  },
  {
    name: 'New Zealand',
    dailCode: '+64',
    code: 'NZ',
  },
  {
    name: 'Nicaragua',
    dailCode: '+505',
    code: 'NI',
  },
  {
    name: 'Niger',
    dailCode: '+227',
    code: 'NE',
  },
  {
    name: 'Nigeria',
    dailCode: '+234',
    code: 'NG',
  },
  {
    name: 'Niue',
    dailCode: '+683',
    code: 'NU',
  },
  {
    name: 'Norfolk Island',
    dailCode: '+672',
    code: 'NF',
  },
  {
    name: 'Northern Mariana Islands',
    dailCode: '+1670',
    code: 'MP',
  },
  {
    name: 'Norway',
    dailCode: '+47',
    code: 'NO',
  },
  {
    name: 'Oman',
    dailCode: '+968',
    code: 'OM',
  },
  {
    name: 'Pakistan',
    dailCode: '+92',
    code: 'PK',
  },
  {
    name: 'Palau',
    dailCode: '+680',
    code: 'PW',
  },
  {
    name: 'Palestinian Territory, Occupied',
    dailCode: '+970',
    code: 'PS',
  },
  {
    name: 'Panama',
    dailCode: '+507',
    code: 'PA',
  },
  {
    name: 'Papua New Guinea',
    dailCode: '+675',
    code: 'PG',
  },
  {
    name: 'Paraguay',
    dailCode: '+595',
    code: 'PY',
  },
  {
    name: 'Peru',
    dailCode: '+51',
    code: 'PE',
  },
  {
    name: 'Philippines',
    dailCode: '+63',
    code: 'PH',
  },
  {
    name: 'Pitcairn',
    dailCode: '+872',
    code: 'PN',
  },
  {
    name: 'Poland',
    dailCode: '+48',
    code: 'PL',
  },
  {
    name: 'Portugal',
    dailCode: '+351',
    code: 'PT',
  },
  {
    name: 'Puerto Rico',
    dailCode: '+1939',
    code: 'PR',
  },
  {
    name: 'Qatar',
    dailCode: '+974',
    code: 'QA',
  },
  {
    name: 'Romania',
    dailCode: '+40',
    code: 'RO',
  },
  {
    name: 'Russia',
    dailCode: '+7',
    code: 'RU',
  },
  {
    name: 'Rwanda',
    dailCode: '+250',
    code: 'RW',
  },
  {
    name: 'Reunion',
    dailCode: '+262',
    code: 'RE',
  },
  {
    name: 'Saint Barthelemy',
    dailCode: '+590',
    code: 'BL',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    dailCode: '+290',
    code: 'SH',
  },
  {
    name: 'Saint Kitts and Nevis',
    dailCode: '+1869',
    code: 'KN',
  },
  {
    name: 'Saint Lucia',
    dailCode: '+1758',
    code: 'LC',
  },
  {
    name: 'Saint Martin',
    dailCode: '+590',
    code: 'MF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    dailCode: '+508',
    code: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    dailCode: '+1784',
    code: 'VC',
  },
  {
    name: 'Samoa',
    dailCode: '+685',
    code: 'WS',
  },
  {
    name: 'San Marino',
    dailCode: '+378',
    code: 'SM',
  },
  {
    name: 'Sao Tome and Principe',
    dailCode: '+239',
    code: 'ST',
  },
  {
    name: 'Saudi Arabia',
    dailCode: '+966',
    code: 'SA',
  },
  {
    name: 'Senegal',
    dailCode: '+221',
    code: 'SN',
  },
  {
    name: 'Serbia',
    dailCode: '+381',
    code: 'RS',
  },
  {
    name: 'Seychelles',
    dailCode: '+248',
    code: 'SC',
  },
  {
    name: 'Sierra Leone',
    dailCode: '+232',
    code: 'SL',
  },
  {
    name: 'Singapore',
    dailCode: '+65',
    code: 'SG',
  },
  {
    name: 'Slovakia',
    dailCode: '+421',
    code: 'SK',
  },
  {
    name: 'Slovenia',
    dailCode: '+386',
    code: 'SI',
  },
  {
    name: 'Solomon Islands',
    dailCode: '+677',
    code: 'SB',
  },
  {
    name: 'Somalia',
    dailCode: '+252',
    code: 'SO',
  },
  {
    name: 'South Africa',
    dailCode: '+27',
    code: 'ZA',
  },
  {
    name: 'South Sudan',
    dailCode: '+211',
    code: 'SS',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    dailCode: '+500',
    code: 'GS',
  },
  {
    name: 'Spain',
    dailCode: '+34',
    code: 'ES',
  },
  {
    name: 'Sri Lanka',
    dailCode: '+94',
    code: 'LK',
  },
  {
    name: 'Sudan',
    dailCode: '+249',
    code: 'SD',
  },
  {
    name: 'Suriname',
    dailCode: '+597',
    code: 'SR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    dailCode: '+47',
    code: 'SJ',
  },
  {
    name: 'Swaziland',
    dailCode: '+268',
    code: 'SZ',
  },
  {
    name: 'Sweden',
    dailCode: '+46',
    code: 'SE',
  },
  {
    name: 'Switzerland',
    dailCode: '+41',
    code: 'CH',
  },
  {
    name: 'Syrian Arab Republic',
    dailCode: '+963',
    code: 'SY',
  },
  {
    name: 'Taiwan',
    dailCode: '+886',
    code: 'TW',
  },
  {
    name: 'Tajikistan',
    dailCode: '+992',
    code: 'TJ',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    dailCode: '+255',
    code: 'TZ',
  },
  {
    name: 'Thailand',
    dailCode: '+66',
    code: 'TH',
  },
  {
    name: 'Timor-Leste',
    dailCode: '+670',
    code: 'TL',
  },
  {
    name: 'Togo',
    dailCode: '+228',
    code: 'TG',
  },
  {
    name: 'Tokelau',
    dailCode: '+690',
    code: 'TK',
  },
  {
    name: 'Tonga',
    dailCode: '+676',
    code: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    dailCode: '+1868',
    code: 'TT',
  },
  {
    name: 'Tunisia',
    dailCode: '+216',
    code: 'TN',
  },
  {
    name: 'Turkey',
    dailCode: '+90',
    code: 'TR',
  },
  {
    name: 'Turkmenistan',
    dailCode: '+993',
    code: 'TM',
  },
  {
    name: 'Turks and Caicos Islands',
    dailCode: '+1649',
    code: 'TC',
  },
  {
    name: 'Tuvalu',
    dailCode: '+688',
    code: 'TV',
  },
  {
    name: 'Uganda',
    dailCode: '+256',
    code: 'UG',
  },
  {
    name: 'Ukraine',
    dailCode: '+380',
    code: 'UA',
  },
  {
    name: 'United Arab Emirates',
    dailCode: '+971',
    code: 'AE',
  },
  {
    name: 'United Kingdom',
    dailCode: '+44',
    code: 'GB',
  },
  {
    name: 'United States',
    dailCode: '+1',
    code: 'US',
  },
  {
    name: 'Uruguay',
    dailCode: '+598',
    code: 'UY',
  },
  {
    name: 'Uzbekistan',
    dailCode: '+998',
    code: 'UZ',
  },
  {
    name: 'Vanuatu',
    dailCode: '+678',
    code: 'VU',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    dailCode: '+58',
    code: 'VE',
  },
  {
    name: 'Vietnam',
    dailCode: '+84',
    code: 'VN',
  },
  {
    name: 'Virgin Islands, British',
    dailCode: '+1284',
    code: 'VG',
  },
  {
    name: 'Virgin Islands, U.S.',
    dailCode: '+1340',
    code: 'VI',
  },
  {
    name: 'Wallis and Futuna',
    dailCode: '+681',
    code: 'WF',
  },
  {
    name: 'Yemen',
    dailCode: '+967',
    code: 'YE',
  },
  {
    name: 'Zambia',
    dailCode: '+260',
    code: 'ZM',
  },
  {
    name: 'Zimbabwe',
    dailCode: '+263',
    code: 'ZW',
  },
];

export const UNSUPPORTED_SMS_COUNTRIES = ['SG', 'US', 'CN'];

export const validCountries = [
  'GB',
  // 'BE',
  // 'CY',
  // 'EE',
  // 'FI',
  // 'FR',
  // 'DE',
  // 'GR',
  // 'IE',
  // 'IT',
  // 'LV',
  // 'LT',
  // 'LU',
  // 'MT',
  // 'NL',
  // 'PT',
  // 'SK',
  // 'SI',
  // 'ES',
  // 'EZ',
  // new countries 20.07.2022
  // 'US',
  // 'ZA',
  // 'CA',
  // 'AU',
  // 'IN',
  // 'CN',
  // 'BR',
  // 'ID',
];

export const getCountryByCode = (code: string): CountryProps | undefined => {
  return countries.find((c) => c.code === code);
};
